import LTR from "@brand-icons/global/stick/stick-ltr.svg";

import { iconFactory } from "../iconFactory";

export const StickIcon = iconFactory("StickIcon", LTR);
